/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface EnumerationConditionSetupParameterAssignment
 */
export interface EnumerationConditionSetupParameterAssignment {
    /**
     * 
     * @type {string}
     * @memberof EnumerationConditionSetupParameterAssignment
     */
    setupParameterId: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationConditionSetupParameterAssignment
     */
    value: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationConditionSetupParameterAssignment
     */
    $type?: EnumerationConditionSetupParameterAssignmentTypeEnum;
}


/**
 * @export
 */
export const EnumerationConditionSetupParameterAssignmentTypeEnum = {
    PtwPtw100AppZeroCoreSharedTaskItemComponentConditionValueAssignmentsEnumerationConditionSetupParameterAssignmentPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.TaskItemComponent.ConditionValueAssignments.EnumerationConditionSetupParameterAssignment, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type EnumerationConditionSetupParameterAssignmentTypeEnum = typeof EnumerationConditionSetupParameterAssignmentTypeEnum[keyof typeof EnumerationConditionSetupParameterAssignmentTypeEnum];



/**
 * Check if a given object implements the EnumerationConditionSetupParameterAssignment interface.
 */
export function instanceOfEnumerationConditionSetupParameterAssignment(value?: unknown): value is EnumerationConditionSetupParameterAssignment {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationConditionSetupParameterAssignmentTypeEnum)[0];
}

export function EnumerationConditionSetupParameterAssignmentFromJSON(json: any): EnumerationConditionSetupParameterAssignment {
    return EnumerationConditionSetupParameterAssignmentFromJSONTyped(json, false);
}

export function EnumerationConditionSetupParameterAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationConditionSetupParameterAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'setupParameterId': json['setupParameterId'],
        'value': json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationConditionSetupParameterAssignmentToJSON(value?: EnumerationConditionSetupParameterAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'setupParameterId': value['setupParameterId'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

